import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './UnassignedQueuePage.scss'
import queueService from './services/QueueService';
import Section from '../../components/layout/Section';
import HrbTranslate from '../../components/language/HrbTranslate';
import QueueTable from './components/QueueTable';
import UnassignedQueueSummary from './components/unassigned/UnassignedQueueSummary';
import { useTimer } from '../../hooks/useTimer';
import UnassignedTicketQueueHeader from './components/unassigned/UnassignedTicketQueueHeader';
import { QueueTableTypes } from './enums/QueueTableTypes';

const UnassignedQueuePage = () => {
    const limit = 25
    const REFRESH_SPEED = 2 * 60;

    const history = useHistory();

    const [sortType, setSortType] = useState(null);
    const [reversed, setReversed] = useState(false)
    const [offset, setOffset] = useState(0);
    const [queue, setQueue] = useState(null);
    const [summary, setSummary] = useState(null);
    const [shouldRefresh, setShouldRefresh] = useState(null);

    const [, stop, isRunning] = useTimer(() => setShouldRefresh(true), REFRESH_SPEED, true);
    localStorage.setItem('pageSelections', JSON.stringify([]));
    localStorage.setItem('reassignTicketIds', JSON.stringify([]));

    const getSummary = async () => {
        var summaryData = await queueService.getUnassignedQueueSummary()
        setSummary(summaryData);
    }

    const getQueue = async () => {
        var queueData = await queueService.getUnassignedQueueTickets(sortType, reversed, limit, offset)
        setQueue(queueData);
    }

    const getData = async () => {
        await Promise.all([getQueue(), getSummary()])
            .catch(err => {
                console.log(err)
            })
    }

    const firstName = useSelector(state => state.accountData.firstName || '')

    useEffect(() => {
        setQueue(null);
        getData();
    }, [sortType, offset, reversed])

    useEffect(() => {
        if (shouldRefresh && isRunning) {
            getData();
        }
        setShouldRefresh(false);
    }, [shouldRefresh])

    useEffect(() => {
        return () => {
            if (isRunning) {
                stop()
            }
        }
    }, []);

    const handleSortChange = (sort, rev) => {
        if (sort !== sortType) {
            setSortType(sort)
            setOffset(0);
        }
        if (reversed !== rev) {
            setReversed(rev)
            setOffset(0);
        }
    }

    const handleViewTicket = (ticketId) => {
        history.push(`/tickets/${ticketId}`)
    }

    const handleViewTarget = (targetId) => {
        history.push(`/clients/${targetId}`)
    }

    const handleSetOffset = (offset) => {
        setOffset(offset)
    }

    return (
        <div className = "content-grid queue" >
            <Section sectionId='section-queue-summary' className='white'>
                <div className='columns'>
                    <div className='column is-10 is-offset-1 homePageHeader' >
                        <h1 className='page-title'>
                            <HrbTranslate text='QueuePage.Labels.Hello' params={{ FirstName: firstName }} />
                        </h1>
                    </div>
                </div>
                <UnassignedQueueSummary summary={summary} onSortChanged={handleSortChange} />
            </Section>
            <Section sectionId='section-queue' className='light-functional-grey'>
                <UnassignedTicketQueueHeader />
                <QueueTable queue={queue} sort={sortType} onSortChanged={handleSortChange}
                    onOpenTicket={handleViewTicket} onOpenTarget={handleViewTarget}
                    onSetOffset={handleSetOffset} tableType={QueueTableTypes.UNASSIGNED} isUnassignedQueue={true} />
            </Section>
        </div>
    );
}

UnassignedQueuePage.whyDidYouRender = false;

export default UnassignedQueuePage